import {
  compose,
  fromPairs,
  map,
  juxt,
  join,
  prepend,
  head,
  last,
  toPairs,
  replace,
  keys,
} from 'ramda';

const getDynamicUrl = (url, params) => {
  // add ':' to params keys, e.g. { id: id } => { ':id': id }
  const transformedParams = compose(
    fromPairs,
    map(juxt([compose(join(''), prepend(':'), head), last])),
    toPairs,
  )(params);

  return replace(
    new RegExp(join('|', keys(transformedParams)), 'g'),
    (match) => transformedParams[match],
    url,
  );
};

export default getDynamicUrl;
